import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.Ledger}`;

export async function getAccountBookStatistics(data) {
  return await Client.get(`${endpoint}/statistics`, data, true);
}

export async function getAccountBookByFieldId(fieldId) {
  return await Client.get(`${endpoint}/${fieldId}`, {}, true);
}

export async function patchUserMetric(id, data) {
  return await Client.patch(`${endpoint}/${id}/userMetric`, data, true);
}

export async function postAccountBookSale(id, data) {
  return await Client.post(`${endpoint}/${id}/sale`, data, true);
}

export async function patchAccountBookSale(id, saleId, data) {
  return await Client.patch(`${endpoint}/${id}/sale/${saleId}`, data, true);
}

export async function deleteAccountBookSale(id, saleId) {
  return await Client.delete(`${endpoint}/${id}/sale/${saleId}`, {}, true);
}

export async function postAccountBookCollection(id, data) {
  return await Client.post(`${endpoint}/${id}/collection`, data, true);
}

export async function patchAccountBookCollection(id, collectionId, data) {
  return await Client.patch(`${endpoint}/${id}/collection/${collectionId}`, data, true);
}

export async function deleteAccountBookCollection(id, collectionId) {
  return await Client.delete(`${endpoint}/${id}/collection/${collectionId}`, {}, true);
}

export async function postAccountBookExpense(id, data) {
  return await Client.post(`${endpoint}/${id}/expense`, data, true);
}

export async function patchAccountBookExpense(id, expenseId, data) {
  return await Client.patch(`${endpoint}/${id}/expense/${expenseId}`, data, true);
}

export async function deleteAccountBookExpense(id, expenseId) {
  return await Client.delete(`${endpoint}/${id}/expense/${expenseId}`, {}, true);
}

export async function uploadLedgerImage(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/uploadFile`, 'image', image, onProgress);
}

export async function downLoadExpenseByDateExcel(id) {
  return await Client.downLoadFile(`${endpoint}/${id}/expenseByDate/excel`, {}, true);
}

export async function downloadExpenseByCategoryExcel(id) {
  return await Client.downLoadFile(`${endpoint}/${id}/expenseByCategory/excel`, {}, true);
}
